const STORAGE_KEY = 'chemkit.review.state.by_reaction';

function readMap() {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_error) {
    return {};
  }
}

function writeMap(next) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (_error) {
    return;
  }
}

export function normalizeReviewState(value) {
  if (value === 'open' || value === 'review_pending' || value === 'signed_off') {
    return value;
  }
  return null;
}

export function rememberReviewState(reactionId, state) {
  const normalizedState = normalizeReviewState(state);
  const numericReactionId = Number.parseInt(String(reactionId), 10);
  if (!Number.isFinite(numericReactionId) || numericReactionId <= 0 || !normalizedState) {
    return;
  }

  const current = readMap();
  current[String(numericReactionId)] = normalizedState;
  writeMap(current);
}

export function getRememberedReviewState(reactionId) {
  const numericReactionId = Number.parseInt(String(reactionId), 10);
  if (!Number.isFinite(numericReactionId) || numericReactionId <= 0) {
    return null;
  }

  const current = readMap();
  return normalizeReviewState(current[String(numericReactionId)]);
}
